import { render, staticRenderFns } from "./add-dialog.vue?vue&type=template&id=3b6472b7&scoped=true&"
import script from "./add-dialog.vue?vue&type=script&lang=js&"
export * from "./add-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-dialog.vue?vue&type=style&index=0&id=3b6472b7&lang=scss&scoped=true&"
import style1 from "./add-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6472b7",
  null
  
)

export default component.exports